import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import general from './modules/general'
import nudge from './modules/nudge'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    menu,
    general,
    nudge
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js